export const GET_ACCESSIBLE_RESOURCES = 'GET_ACCESSIBLE_RESOURCES'
export const GET_ATTENDANCE_OFFSET_DAYS = 'GET_ATTENDANCE_OFFSET_DAYS'
export const GET_ACCESSIBLE_INTERACTIONS = 'GET_ACCESSIBLE_INTERACTIONS'
export const GET_ACTIVE_FILTER = 'GET_ACTIVE_FILTER'
export const CHANGED_FILTER_ON_RESOURCES = 'CHANGED_FILTER_ON_RESOURCES'
export const GET_ENGAGEMENT_SCORE_FOR_ACCESSIBLE = 'GET_ENGAGEMENT_SCORE_FOR_ACCESSIBLE'
export const FILTER_ENGAGEMENT_SCORES = 'FILTER_ENGAGEMENT_SCORES'
export const GET_ACCESSIBLE_ATTENDANCE = 'GET_ACCESSIBLE_ATTENDANCE'
export const GET_ACCESSIBLE_MODULE_ATTENDANCE = 'GET_ACCESSIBLE_MODULE_ATTENDANCE'
export const GET_ACCESSIBLE_STUDENT_MODULES = 'GET_ACCESSIBLE_STUDENT_MODULES'
export const GET_STUDENT_ASSESSMENTS_ACCESSIBLE_LIST = 'GET_STUDENT_ASSESSMENTS_ACCESSIBLE_LIST'
export const GET_ACCESSIBLE_ASSESSMENTS_SUMMARY_BY_ACADEMIC_YEAR = 'GET_ACCESSIBLE_ASSESSMENTS_SUMMARY_BY_ACADEMIC_YEAR'
export const RESET_ACCESSIBLE_ASSESSMENTS_DATA = 'RESET_ACCESSIBLE_ASSESSMENTS_DATA'
export const RESET_ACCESSIBLE_ATTENDANCE_DATA = 'RESET_ACCESSIBLE_ATTENDANCE_DATA'
export const RESET_ACCESSIBLE_ENGAGEMENT_DATA = 'RESET_ACCESSIBLE_ENGAGEMENT_DATA'
export const RESET_ACCESSIBLE_INTERACTIONS_DATA = 'RESET_ACCESSIBLE_INTERACTIONS_DATA'
export const RESET_ACCESSIBLE_MODULES_DATA = 'RESET_ACCESSIBLE_MODULES_DATA'
export const RESET_ACCESSIBLE_RESOURCES_DATA = 'RESET_ACCESSIBLE_RESOURCES_DATA'



// WEBPACK FOOTER //
// ./src/store/modules/accessibility/accessible-action-types.js